document.addEventListener("DOMContentLoaded", (event)=>{

    const menuMobileItems = document.querySelectorAll('.foundation-menu__mobile #menu-fundacja .menu-item-has-children');
    menuMobileItems.forEach((menuItem)=>{
        const newSpan = document.createElement('span');
        newSpan.textContent = '';
        newSpan.classList.add('mobile-toogle');
        newSpan.addEventListener('click', (e) => {
            e.preventDefault();
            const parent = e.target.parentElement;
            parent.classList.toggle('is-expanded');
        });

        menuItem.prepend(newSpan);
    });


});

